import React, { useEffect } from 'react';
import { Form, Input, Table } from 'antd';
import { TableListProduct } from '../TableListProduct';

import * as S from './styled';

import { columns } from './columns';
import { useOverwriteStores } from './useOverwriteStores';

export interface PlanogramFromProductView {
    id: number;
    planogram_code: string;
    status: string;
    standard_amount: number;
    alert_level: number;
    price_list_in_cents: number;
    price_final_in_cents: number;
    stock_amount: number;
    name: string;
    store_id: number;
    modified?: boolean;
}

export const PlanogramReview = () => {
    const form = Form.useFormInstance();

    const {
        storeIds,
        planogram,
        planograms,
        planogramExistsInStores,
        storesToOverwrite,
        isLoading,
    } = useOverwriteStores();

    const dataSource = planogram ? [planogram] : [];

    const rowSelection = {
        onChange: (newSelectedRowKeys: React.Key[]) => {
            form.setFieldValue('stores', newSelectedRowKeys);
        },
    };

    const syncPlanogramModified = () => {
        if (storeIds?.length) {
            const formatedPlanogram: PlanogramFromProductView[] =
                planograms?.planogram?.map((planogram) => ({
                    id: planogram.id,
                    planogram_code: planogram.planogram_code,
                    status: planogram.status,
                    standard_amount: planogram.standard_amount,
                    alert_level: planogram.alert_level,
                    price_list_in_cents: planogram.price_list_in_cents,
                    price_final_in_cents: planogram.price_final_in_cents,
                    stock_amount: planogram.stock_amount,
                    name: planogram.store.name,
                    store_id: planogram.store_id,
                })) || [];

            const planogramModified = [...formatedPlanogram];

            if (storeIds?.length === 0) {
                form.setFieldValue('planogramModified', planogramModified);
                return;
            }
            storeIds?.forEach((storeId) => {
                const planogramFound = planogramModified.findIndex(
                    (store) => store.store_id === storeId,
                );
                if (planogramFound === -1) {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
                    const store = planogramExistsInStores?.find(
                        (store) => store.id === storeId,
                    )!;
                    planogramModified.push({
                        planogram_code: planogram.planogram_code,
                        status: planogram.status,
                        standard_amount: planogram.standard_amount,
                        alert_level: planogram.alert_level,
                        price_list_in_cents: planogram.price_list_in_cents,
                        price_final_in_cents: planogram.price_final_in_cents,
                        stock_amount: planogram.stock_amount,
                        name: store.name,
                        id: 0,
                        store_id: store.id,
                        modified: true,
                    });
                    return;
                }
                planogramModified[planogramFound] = {
                    ...planogramModified[planogramFound],
                    planogram_code: planogram.planogram_code,
                    status: planogram.status,
                    standard_amount: planogram.standard_amount,
                    alert_level: planogram.alert_level,
                    price_list_in_cents: planogram.price_list_in_cents,
                    price_final_in_cents: planogram.price_final_in_cents,
                    stock_amount: planogram.stock_amount,
                    modified: true,
                };
            });
            form.setFieldValue('planogramModified', planogramModified);
        }
    };

    useEffect(() => {
        if (planogram) {
            form.setFieldValue(
                'planogramQnt',
                planograms?.planogram?.length || 0,
            );
        }
    }, [planogram]);

    useEffect(() => {
        /**
         * `skipAccept`/`confirmOverwrite` are also read outside this modal
         * (e.g. the product page's own "Salvar" button in UpdateProduct),
         * so this sync must be kept even though the overwrite warning is no
         * longer rendered inline here.
         */
        if (storesToOverwrite.length === 0 && !!storeIds?.length) {
            form.setFieldValue('skipAccept', true);
            form.setFieldValue('confirmOverwrite', false);
        }

        if (storesToOverwrite.length > 0 && !!storeIds?.length) {
            form.setFieldValue('skipAccept', false);
        }

        if (storeIds?.length === 0) {
            form.setFieldValue('confirmOverwrite', false);
            form.setFieldValue('skipAccept', false);
        }
    }, [storesToOverwrite, storeIds]);

    useEffect(() => {
        syncPlanogramModified();
    }, [storeIds, planogram]);

    return (
        <S.Container>
            <TableListProduct dataSource={dataSource} pagination={false} />
            <S.StoresArea>
                <Form.Item name="stores" hidden>
                    <Input type="hidden" />
                </Form.Item>
                <Form.Item name="planogramModified" hidden>
                    <Input type="hidden" />
                </Form.Item>
                <Form.Item name="planogramQnt" hidden>
                    <Input />
                </Form.Item>
                <S.StoresTitle>
                    Escolha as lojas para criar os planogramas:
                </S.StoresTitle>
                <S.TableWrapper>
                    <Table
                        pagination={false}
                        dataSource={planogramExistsInStores}
                        loading={isLoading}
                        rowKey="id"
                        scroll={{
                            x: 'max-content',
                        }}
                        columns={columns}
                        rowSelection={rowSelection}
                    />
                </S.TableWrapper>
            </S.StoresArea>
        </S.Container>
    );
};
